import type { CSSProperties } from 'react';

export interface BdayTheme {
  accent: string;
  accentSoft: string;
  accentGlow: string;
  ink: string;
  bgDeep: string;
  bgMid: string;
  surface: string;
  surfaceGlass: string;
  muted: string;
  border: string;
}

export const bdayTheme: BdayTheme = {
  accent: '#60a5fa',       // blue-400
  accentSoft: '#bfdbfe',   // blue-200
  accentGlow: '#1d4ed8',   // blue-700
  ink: '#f0f9ff',          // sky-50 — white text on dark blue
  bgDeep: '#0f172a',       // slate-900
  bgMid: '#1e3a5f',        // custom deep navy
  surface: '#1e3799',      // deep blue card
  surfaceGlass: 'rgba(30, 55, 153, 0.45)',
  muted: '#93c5fd',        // blue-300
  border: 'rgba(96, 165, 250, 0.20)',
};

export const BDAY_EASE = [0.22, 1, 0.36, 1] as const;

export function themeCssVars(t: BdayTheme): CSSProperties {
  return {
    '--bd-accent': t.accent,
    '--bd-accent-soft': t.accentSoft,
    '--bd-accent-glow': t.accentGlow,
    '--bd-ink': t.ink,
    '--bd-bg-deep': t.bgDeep,
    '--bd-bg-mid': t.bgMid,
    '--bd-surface': t.surface,
    '--bd-surface-glass': t.surfaceGlass,
    '--bd-muted': t.muted,
    '--bd-border': t.border,
  } as CSSProperties;
}
